class FreeGiftOffer extends HTMLElement {
    constructor(){
        super();
        this.data = JSON.parse(this.querySelector('[data-free-gift-offer]').innerText);
        this.onCartPage = document.querySelector('cart-items') != null;
        if(this.onCartPage){
            let cartDiscountCodeContainer = document.querySelector('.cart-discount-code');
            this.data.forEach(freeGiftOffer => {
                if(freeGiftOffer.already_in_cart && freeGiftOffer.discount_code != ''){
                    cartDiscountCodeContainer.innerHTML += `
                        <button type='button' class='discount-code-copy-button button button--tertiary' data-copy-discount-code>
                            Your free gift discount code is <span data-discount-code class='discount-code'>${freeGiftOffer.discount_code}</span> Click here to copy it to your clipboard
                        </button>
                    `;
                }
            })
        }
    }
    getOfferBannerData(){
        return this.data.map(freeGiftOffer => {
            return {
                enabled: freeGiftOffer.enable_banner,
                message: freeGiftOffer.message
            }
        })
    }
    refreshRunningTotals(){
        fetch('/?sections=free-gift-offer')
        .then(response => response.json())
        .then(data => {
            let parsedHtml = new DOMParser().parseFromString(data['free-gift-offer'], 'text/html');
            this.innerHTML = parsedHtml.querySelector('free-gift-offer').innerHTML;
            this.data = JSON.parse(this.querySelector('[data-free-gift-offer]').innerText);
            this.data.forEach(freeGiftOffer => {
                if(!freeGiftOffer.already_in_cart){
                    this.checkThreshold(freeGiftOffer);
                }
            })
        })
    }
    checkThreshold(freeGiftOffer){
        if (freeGiftOffer.running_total >= freeGiftOffer.threshold){

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData();
            formData.append('id', freeGiftOffer.free_gift_vid);
            formData.append('quantity', 1);
            formData.append('properties[_Free_Gift]', true);          
            config.body = formData;

            if (this.onCartPage){
                document.querySelector('cart-items').classList.add('adding-gift')
            }

            fetch(`${routes.cart_add_url}`, config)
            .then(response => {return response.json()})
            .then(data => {
                if (this.onCartPage){
                    window.location.reload();
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }
}

customElements.define('free-gift-offer', FreeGiftOffer)